
        var result = require("!!../../../../node_modules/css-loader/index.js!./dashboard1.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/dashboard1/dashboard1.component.css
// module id = 726
// module chunks = 0